import Loadable from "@loadable/component"
import ml5 from "ml5"
// const ml5 = Loadable(() => {
//   import("ml5")
// })

export default function Sketch(p) {
  let label = ""
  let probability = ""
  let classifier
  let video

  const gotResult = (err, result) => {
    if (err) {
      console.error(err)
    } else {
      label = result[0].label.toUpperCase()
      probability = (result[0].confidence * 100).toFixed(2)
      classifier.classify(gotResult)
    }
  }
  const modelOnLoaded = () => {
    console.log("Model is Successfully Loaded!")
  }
  const videoReady = () => {
    classifier.classify(gotResult)
  }

  p.setup = () => {
    p.createCanvas(640, 480)
    video.hide()
    p.background(0)
  }

  p.draw = () => {
    p.background(0)
    p.image(video, 0, 0)
    p.fill(0)
    p.textSize(32)
    p.text(label, 10, p.height - 100)
    p.text(probability, 10, p.height - 30)
  }

  p.preload = () => {
    video = p.createCapture(p.VIDEO, videoReady)
    classifier = ml5.imageClassifier("MobileNet", video, modelOnLoaded)
  }
}
